import { GET_CARTRULE_REQUESTED, EDIT_CARTRULE_REQUESTED } from './edit.actions';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import { Component, OnInit } from '@angular/core';
import store from './../../../store/store.module';
import {FETCH_CARTRULES_REQUESTED} from "../list/list.actions";
import {CARTRULE_COMP, GET_ALL_CARTRULE_MENU_REQUESTED, GET_CARTRULE_TEMPLATE_REQUESTED} from "../cartrule.action";
import * as moment from 'moment';
import * as _ from 'lodash';
import {FETCH_CONSTANTS_REQUESTED} from "../../../store/constant/list/list.actions";
import {CREATE_CARTRULE_ERROR, CREATE_CARTRULE_REQUESTED} from "../create/create.actions";
import ArrayList from "../../../models/ArrayList";
import {FETCH_PRODUCT_DETAIL_REQUESTED} from "../../product/detail/detail.actions";
import {DELETE_COUPON_REQUESTED} from "../../coupon/edit/edit.actions";
import {UtilityService} from "../../../common/services/utility/utility.service";

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditComponent implements OnInit {
  public static defaultCoupon = {
    code: '',
    usage_limit: 1,
    usage_per_customer: 1,
    valid_from: moment(),
    valid_to: moment().add(1),
    is_active: true
  };
  public store = store;
  public cartrule: any = {};
  public coupons = [];
  public mainCondition;
  public mainAction;
  public utilityService;
  public redirectData;

  constructor(private router: Router, private route: ActivatedRoute, utilityService: UtilityService) {
    this.utilityService = utilityService;
  }

  ngOnInit() {
    this.redirectData = this.utilityService.getRedirectData();
    store.dispatch({ type: GET_CARTRULE_REQUESTED, data: this.getCartruleId() });
    store.dispatch({ type: FETCH_CONSTANTS_REQUESTED });
    store.dispatch({ type: GET_ALL_CARTRULE_MENU_REQUESTED });
    let firstTimeInit = store.subscribe(() => {
      if (store.getState().Cartrule.allMenu.fetched && (store as any).getState().Cartrule.edit.fetched) {
        this.mainCondition = store.getState().Cartrule.allMenu.item.conditions.find(s => s.main === true);
        this.mainAction = store.getState().Cartrule.allMenu.item.actions.find(s => s.main === true);

        this.cartrule = {
          ..._.omit((store as any).getState().Cartrule.edit.item, ['coupons']),
          valid_from: (store as any).getState().Cartrule.edit.item.getCartruleValidFrom(),
          valid_to: (store as any).getState().Cartrule.edit.item.getCartruleValidTo()
        };
        this.coupons = [
          ...(store as any).getState().Cartrule.edit.item.coupons.getContent().map(s => {
            return {
              ...s,
              valid_from: s.getCouponValidFrom(),
              valid_to: s.getCouponValidTo()
            };
          })
        ];
        firstTimeInit();
      }
    });
  }

  onSubmit(form) {
    if (form.valid) {
      if (_.uniqBy(this.coupons, 'code').length !== this.coupons.length) {
        store.dispatch({ type: CREATE_CARTRULE_ERROR, message: 'Coupon should be unique' });
        return;
      }
      let req = {
        ..._.omit(this.cartrule, ['coupon_prefix']),
        coupons: [
          ...this.coupons.map(s => {
            let prefix = this.cartrule['coupon_prefix'] ? this.cartrule['coupon_prefix'] : '';
            return {
              ..._.omit(s, ['key', 'code']),
              code: prefix + (s.code ? s.code : '')
            };
          })
        ]
      };
      store.dispatch({ type: EDIT_CARTRULE_REQUESTED, data: req });
    }
  }
  updateCondition(val) {
    (this.cartrule as any).condition = val;
  }
  updateActionCondition(val) {
    (this.cartrule as any).action_to_condition = val;
  }
  removeCoupon(coupon) {
    if (coupon.key) {
      this.coupons = this.coupons.filter(s => s.key !== coupon.key);
    } else {
      if (confirm('Do you want to delete this coupon?')) {
        store.dispatch({ type: DELETE_COUPON_REQUESTED, data: coupon.id, cartruleId: this.cartrule.id, com: CARTRULE_COMP });
      }
    }
  }
  addCoupon() {
    this.coupons.push({
      key: this.generateRandomCouponId(),
      ...EditComponent.defaultCoupon
    });
  }
  generateRandomCouponId() {
    return Math.random().toString(36).substring(7);
  }
  couponTracker(index, item) {
    if (item.id) {
      return item.id;
    }
    return item.key;
  }
  getCartruleId() {
    return this.route.snapshot.paramMap.get('id');
  }

}
